/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadBatchDocument } from './UploadBatchDocument';
import {
    UploadBatchDocumentFromJSON,
    UploadBatchDocumentFromJSONTyped,
    UploadBatchDocumentToJSON,
    UploadBatchDocumentToJSONTyped,
} from './UploadBatchDocument';

/**
 * 
 * @export
 * @interface UploadBatch
 */
export interface UploadBatch {
    /**
     * 
     */
    batch_id: string;
    /**
     * 
     */
    documents: Array<UploadBatchDocument>;
}

/**
 * Check if a given object implements the UploadBatch interface.
 */
export function instanceOfUploadBatch(value: object): value is UploadBatch {
    if (!('batch_id' in value) || value['batch_id'] === undefined) return false;
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function UploadBatchFromJSON(json: any): UploadBatch {
    return UploadBatchFromJSONTyped(json, false);
}

export function UploadBatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadBatch {
    if (json == null) {
        return json;
    }
    return {
        
        'batch_id': json['batch_id'],
        'documents': ((json['documents'] as Array<any>).map(UploadBatchDocumentFromJSON)),
    };
}

export function UploadBatchToJSON(json: any): UploadBatch {
    return UploadBatchToJSONTyped(json, false);
}

export function UploadBatchToJSONTyped(value?: UploadBatch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'batch_id': value['batch_id'],
        'documents': ((value['documents'] as Array<any>).map(UploadBatchDocumentToJSON)),
    };
}

